import ShareUtil from './ShareUtil';

class ShareKakaoLink{
  constructor( $node, opts ){

    this.$node = $node;
    this.setOptions( opts );

  	let kakaoKey = this.setKey( location.href );

    if( !kakaoKey ) return;

    if( window.Kakao ){
      this.kakaoInit( kakaoKey );
    }else{
      ShareUtil.loadJs('https://developers.kakao.com/sdk/js/kakao.min.js', () => {
        //callback
        if( window.Kakao ){
          this.kakaoInit( kakaoKey );
        }
      });
    }
  }

  kakaoInit( kakaoKey ){
    window.Kakao.init( kakaoKey );
    window.Kakao.Link.createDefaultButton( this.setKakaoOptions() );
  }

  setOptions( opts ) {
  	this.msg = opts.msg;
  	this.url = decodeURIComponent( opts.url );
  	this.appid = opts.appid;
  	this.appver = opts.appver;
  	this.appname = opts.appname;
    this.description = opts.description;
    this.img = opts.img;
    this.imgWidth = opts.imgWidth || 300;
    this.imgHeight = opts.imgHeight || 200;
    this.buttonMsg = opts.buttonMsg || opts.appname;
  }

  setKakaoOptions(){
    return {
        container: this.$node.get( 0 ),
        objectType: "feed",
        installTalk: true,
        content: {
            title: this.buttonMsg,
            imageUrl: this.img,
            link: {
                webUrl: this.url,
                mobileWebUrl: this.url
            },
            description: this.msg
        }
    };
  }

  resetKakaoLink( options ) {

    let This = this;

    this.setOptions( options );

    if( Kakao ){

      Kakao.Link.cleanup();

      let kakaoKey = this.setKey( location.href );
      if( !kakaoKey ) return;

      //Kakao.init( kakaoKey );
      Kakao.Link.createDefaultButton( This.setKakaoOptions() );

    }
  }

  setKey( loc ){
      if (/lineage.plaync.co/.test(loc)) {
          return "cc821832de1815dfefd89696a8328808";
      } else if (/lineagem.plaync.co/.test(loc)) {
          return "fed893c76cbaa6fe574a28bb723c4906";
      } else if (/lineage2.plaync.co/.test(loc)) {
          return "5c2686ba412a29a8fb2942339184d320";
      } else if (/lineage2m.plaync.co/.test(loc)) {
          return "6496c02f43605383083cccf9f7f79cf3";
      } else if (/bns.plaync.co/.test(loc)) {
          return "7a41aad1eebf7e5b4b68db7204aeb574";
      } else if (/aion.plaync.co/.test(loc)) {
          return "6c3e99b13fbec7bc6c4d699de19d8e3a";
      } else if (/h2.plaync.co/.test(loc)) {
          return "1af018ac29fd1c88bf279ca5f999c97f";
      } else if (/fb.plaync.co/.test(loc)) {
          return "b18b4f83affd1baa323d43cb76ccde55";
      } else if (/event.plaync.co/.test(loc)) {
          return "938e491a6a7a61dee6ad1293a191d999";
      } else if (/plaync.co/.test(loc) || /asia.nc.com/.test(loc)) {
          return "787f3aa15494fd0879123c1cce573c9b";
      } else if (/ui-static.korea/.test(loc)) {
          return "b5c5048fcf2c4c8376c7047cf4c6d859";
      } else if (/buff.plaync.co/.test(loc)) {
          return "9693c286b09a8c591084ffcf6a17798d";
      }
      return "address error";
  };
}

export default ShareKakaoLink;
